import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  Input,
  Table,
  Space,
  Popconfirm,
  // Select,
  Col,
  Row,
  Tooltip,
  Form,
  Button
} from "antd";
// import { confirmAlert } from "react-confirm-alert";
import { getRequest, postRequest } from "../../axios";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";

import { debounce } from "lodash";
import ButtonField from "../../common/htmlComponents/ButtonField";
import SearchIcon from "../../image/SearchIcon.svg";
import "react-confirm-alert/src/react-confirm-alert.css";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { UndoOutlined } from "@ant-design/icons";
// import { authUserData } from "../../utils/Helper";

const { Search } = Input;

const ArchivedEmployeeList = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  // const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [loading, setLoading] = useState(false);
  const [archivedEmployeeList, setArchivedEmployeeList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  // const { Option } = Select;

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getEmployeeArchiveList = async () => {
      setLoading(true);
      try {
        // let apiResponse = await getRequest(`employee-archive/?company_id=${CompanyId}`, state);
        let apiResponse = await getRequest(`employee/archived-employee-list/?role=Employee`, state);
        if (apiResponse?.data?.results?.success) {

          // const sortedData = apiResponse.data.results.data.sort((a, b) => {
          //   return a.id - b.id;
          // });

          setArchivedEmployeeList(apiResponse?.data?.results?.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archive_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getEmployeeArchiveList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    // const start = (pagination.current - 1) * pagination.pageSize;
    // const end = start + pagination.pageSize;
 

    // const newSelectedRows = [...selectedRow.slice(0, start), ...selectedRow.slice(end)];
    // setSelectedRow(newSelectedRows);
    setSelectedRow(selectedRow)
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "company_name" && sortOrder === "ascend") {
      sortingEnumKey = "company_name";
    }
    if (sortField === "company_name" && sortOrder === "descend") {
      sortingEnumKey = "-company_name";
    }
    if (sortField === "name" && sortOrder === "ascend") {
      sortingEnumKey = "name";
    }
    if (sortField === "name" && sortOrder === "descend") {
      sortingEnumKey = "-name";
    }



    if (sortField === "address" && sortOrder === "ascend") {
      sortingEnumKey = "address";
    }
    if (sortField === "address" && sortOrder === "descend") {
      sortingEnumKey = "-address";
    }

    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }

    if (sortField === "phone" && sortOrder === "ascend") {
      sortingEnumKey = "phone";
    }
    if (sortField === "phone" && sortOrder === "descend") {
      sortingEnumKey = "-phone";
    }

    if (sortField === "work_on" && sortOrder === "ascend") {
      sortingEnumKey = "work_on";
    }
    if (sortField === "work_on" && sortOrder === "descend") {
      sortingEnumKey = "-work_on";
    }
    if (sortField === "abn_number" && sortOrder === "ascend") {
      sortingEnumKey = "abn_number";
    }
    if (sortField === "abn_number" && sortOrder === "descend") {
      sortingEnumKey = "-abn_number";
    }
    if (sortField === "tax_file_number" && sortOrder === "ascend") {
      sortingEnumKey = "tax_file_number";
    }
    if (sortField === "tax_file_number" && sortOrder === "descend") {
      sortingEnumKey = "-tax_file_number";
    }
    if (sortField === "account_holder_name" && sortOrder === "ascend") {
      sortingEnumKey = "account_holder_name";
    }
    if (sortField === "account_holder_name" && sortOrder === "descend") {
      sortingEnumKey = "-account_holder_name";
    }

    if (sortField === "account_number" && sortOrder === "ascend") {
      sortingEnumKey = "account_number";
    }
    if (sortField === "account_number" && sortOrder === "descend") {
      sortingEnumKey = "-account_number";
    }

    if (sortField === "bank_name" && sortOrder === "ascend") {
      sortingEnumKey = "bank_name";
    }
    if (sortField === "bank_name" && sortOrder === "descend") {
      sortingEnumKey = "-bank_name";
    }

    if (sortField === "branch_name" && sortOrder === "ascend") {
      sortingEnumKey = "branch_name";
    }
    if (sortField === "branch_name" && sortOrder === "descend") {
      sortingEnumKey = "-branch_name";
    }

    if (sortField === "ifsc_code" && sortOrder === "ascend") {
      sortingEnumKey = "ifsc_code";
    }
    if (sortField === "ifsc_code" && sortOrder === "descend") {
      sortingEnumKey = "-ifsc_code";
    }

    if (sortField === "emergency_contact_person_name" && sortOrder === "ascend") {
      sortingEnumKey = "emergency_contact_person_name";
    }
    if (sortField === "emergency_contact_person_name" && sortOrder === "descend") {
      sortingEnumKey = "-emergency_contact_person_name";
    }

    if (sortField === "emergency_contact_person_no" && sortOrder === "ascend") {
      sortingEnumKey = "emergency_contact_person_no";
    }
    if (sortField === "emergency_contact_person_no" && sortOrder === "descend") {
      sortingEnumKey = "-emergency_contact_person_no";
    }

    if (sortField === "visa_type" && sortOrder === "ascend") {
      sortingEnumKey = "visa_type";
    }
    if (sortField === "visa_type" && sortOrder === "descend") {
      sortingEnumKey = "-visa_type";
    }

    if (sortField === "driving_license" && sortOrder === "ascend") {
      sortingEnumKey = "driving_license";
    }
    if (sortField === "driving_license" && sortOrder === "descend") {
      sortingEnumKey = "-driving_license";
    }

    if (sortField === "term_condition_accept" && sortOrder === "ascend") {
      sortingEnumKey = "term_condition_accept";
    }
    if (sortField === "term_condition_accept" && sortOrder === "descend") {
      sortingEnumKey = "-term_condition_accept";
    }

    if (sortField === "police_check" && sortOrder === "ascend") {
      sortingEnumKey = "police_check";
    }
    if (sortField === "police_check" && sortOrder === "descend") {
      sortingEnumKey = "-police_check";
    }


    if (sortField === "status" && sortOrder === "ascend") {
      sortingEnumKey = "status";
    }
    if (sortField === "status" && sortOrder === "descend") {
      sortingEnumKey = "-status";
    }

    return sortingEnumKey;
  };

  // const handleStatus = async (user_id, status) => {
  //   confirmAlert({
  //     title: t("confirmAlert_title"),
  //     message: t("confirmAlert_message"),
  //     buttons: [
  //       {
  //         label: t("confirmAlert_ok"),
  //         onClick: () => changeStatus(user_id, status),
  //       },
  //       {
  //         label: t("confirmAlert_cancel"),
  //         onClick: () => navigate("/employee/archive"),
  //       },
  //     ],
  //   });
  // };

  // const changeStatus = async (id, value) => {
  //   await patchRequest(`employee-status/${id}/`, { status: value })
  //     .then((response) => {
  //       SuccessNotificationMsg(t("status_updated_sucessfully"));
  //       setReload(!reload);
  //       setLoading(false);
  //     })
  //     .catch((error) => {});
  // };

  const handleReset=()=>{
    setState({
      ...state,
search:"",
    });
    // setState({
    //   ...state,
    //   search: "",
    //   status: "",
    //   page: 1,
    // });
    form.setFieldsValue({ search: "" });
  }
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {

    },
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected ? [...selectedRow, record.id] : selectedRow.filter(key => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected ? [...selectedRow, ...changeRows.map(row => row.id)] : selectedRow.filter(key => !changeRows.find(row => row.id === key));
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("employee/restore-employee/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("employee_restore_successfully"));
        setReload(!reload);
        navigate("/employee");
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_restore_employee"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: 150,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
        // </Tooltip>
      ),
    },
    
    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
      sorter: true,
      width: 230,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
        // </Tooltip>
      ),
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
        // </Tooltip>
      ),
    },
    
    {
      title: "Contact Number",
      dataIndex: "phone",
      key: "phone",
      width: 180,
      //render: (phone) => <>+{phone} </>,
      render: (phone) => {
        // Assuming phone is a number or string containing the phone number
        if (phone) {
          // Remove any non-numeric characters from the phone number
          const cleanedPhone = String(phone).replace(/\D/g, '');
    
          // Check if the cleaned phone number starts with "+91" or any other country code
          if (cleanedPhone.startsWith("91")) {
            // Format as +91 xxxxx xxxxx (for Indian numbers)
            return `+91 ${cleanedPhone.slice(2, 7)} ${cleanedPhone.slice(7)}`;
          } else {
            // Default format: +{country code} xxxxx xxxxx (adjust as per your country code format)
            return `+${cleanedPhone}`;
          }
        }
        return null; // Handle null or undefined cases
      },
      sorter: true,
    },

    {
      title: "Work On",
      dataIndex: "work_on",
      key: "work_on",
      sorter: true,
      width: 160,
   
    },
    {
      title: "ABN Number",
      dataIndex: "abn_number",
      key: "abn_number",
      sorter: true,
       width: 120,
    },
    {
      title: "Tax File Number",
      dataIndex: "tax_file_number",
      key: "tax_file_number",
      sorter: true,
       width: 120,
    },
    {
      title: "Account Holder Name",
      dataIndex: "account_holder_name",
      key: "account_holder_name",
      sorter: true,
       width: 160,
       render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
        // </Tooltip>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
             {/* <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Restore</span>}
          > */}
          <Popconfirm
            className="action"
            title={t("pop_restore_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleRestore(record.id)}
          >
            <ArchiveRestore className="ArchiverestorImg" />
          </Popconfirm>
          {/* </Tooltip> */}
        </Space>
      ),
    },
  ];
  const colors = ["#737373"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Archived Entries Retain Historical Data And Can Be Reinstated If Necessary.
                </span>
              }
            > */}
              <h3>{t("archived_employee_list")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/employee">{t("employeeList")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("archiveList")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            {" "}
            <div className="searchwrp" style={{ height: "40px" }}>
              <Space direction="vertical">
              <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      // value={state.search}
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                      style={{
                        width: 250,
                      }}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
{
          state?.search?  
          //  <Tooltip title="Reset search">
          <Button
            className="BlueShadowBtn"
            type="primary"
            htmlType="button"
            onClick={() => handleReset()}
          >
            <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} /> Reset
                  </span>
          </Button>
        // </Tooltip>
        :""
}
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  type="primary"
                  htmlType="button"
                  label="Restore"
                  className="BlueShadowBtn"
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="PR-body">
          <Row className="tblheader">
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              className="tbl-heading"
            ></Col>
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 200,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  type="primary"
                  htmlType="button"
                  label="Restore"
                  className="BlueShadowBtn"
                />
              </Popconfirm>
            )}
          </Col> */}
          </Row>

          <Table
            scroll={{
              x: 1200,
            }}
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={archivedEmployeeList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} items`,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          <div className="FormFooter Container">
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("Back to List")}
              onClick={() =>
                navigate(
                  `/employee`
                )
              }
            //onClick={() => setCurrentIndex(0)}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ArchivedEmployeeList;
